import * as yup from "yup";

function isIdpUrl(value: string | undefined | null): boolean {
  if (!value) return true;
  try {
    const trimmed = value.trim();
    if (!trimmed) return true;
    const parsed = new URL(trimmed);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export const idpUrlSchema = yup
  .string()
  .test("idp-url", "Must be a valid URL (http or https)", isIdpUrl);
